/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_TypeInputs */



/**
* | output |
* | --- |
* | "Project Type" |
*
* @param {Options_General_Project_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type = /** @type {((inputs?: Options_General_Project_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekttyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの種類")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de projeto")
	return /** @type {LocalizedString} */ ("Project Type")
});